import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {KeyLog} from '../../../types/data.types';
import {KeyLogService} from '../../../services/key-log.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'key-log-view',
    templateUrl: './key-log-view.component.html',
    styleUrls: ['./key-log-view.component.scss']
})
export class KeyLogViewComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: KeyLog = new KeyLog();

    constructor(public keyLogService: KeyLogService,
                public urlService: UrlService) {}

    ngOnInit() {
        this.data = this.keyLogService.keyLoginKeyLogModal;
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        this.keyLogService.isViewModalShow = false;
        this.keyLogService.keyLoginKeyLogModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-view/key-log-view.component.ts